'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibSubtitle = require('./components/BibSubtitle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibSubtitle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-subtitle/lib/index.js
// module id = 1233
// module chunks = 0